module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'waiting-for-delivery'
      }
    }
  }, [_vm._v("Gaida piegādi")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'waiting-for-delivery-edit',
        params: {
          id: _vm.cart.id
        }
      }
    }
  }, [_vm._v("#" + _vm._s(_vm.cart.id))]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Pievienot preces")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui attached segment"
  }, [_c('category-menu'), _vm._v(" "), (_vm.storeStatus.loading) ? _c('div', {
    staticClass: "ui active centered inline loader",
    staticStyle: {
      "padding": "20px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.storeStatus.loading) ? _c('div', {
    staticClass: "ui stackable three cards"
  }, _vm._l((_vm.goods), function(item) {
    return _c('div', {
      staticClass: "ui fluid card"
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/good/' + item.link)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "padding": "5px",
        "z-index": "100"
      }
    }, _vm._l((item.badges), function(badge) {
      return _c('a', {
        staticClass: "ui label",
        style: ({
          backgroundColor: '#' + badge.color,
          color: '#210404'
        })
      }, [_vm._v(_vm._s(badge.label))])
    }), 0), _vm._v(" "), (item.images[0]) ? _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": item.images[0].url
      }
    }) : _c('img', {
      staticClass: "ui centered image",
      attrs: {
        "src": 'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/' + item.id + '.jpg'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('router-link', {
      staticClass: "header",
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "to": '/good/' + item.link
      }
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('div', {
      staticClass: "ui tag labels"
    }, [_c('a', {
      staticClass: "ui custom_brown label"
    }, [_vm._v("\n\n                Cena: " + _vm._s(_vm.realPrice(item)) + " €\n              ")]), _vm._v(" "), (item.bail > 0) ? _c('a', {
      staticClass: "ui green label"
    }, [_vm._v("\n                Drošības nauda: " + _vm._s(item.bail) + " €\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n              " + _vm._s(item.description) + "\n            ")])], 1), _vm._v(" "), (!_vm.checkIfInCart(item)) ? _c('button', {
      staticClass: "ui bottom attached button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    }), _vm._v(" Pievienot\n          ")]) : _c('div', {
      staticClass: "ui three bottom attached  buttons"
    }, [_c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.reduceItemInCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "minus icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'waiting-for-delivery-edit',
            params: {
              id: _vm.cart.id
            }
          })
        }
      }
    }, [_c('i', {
      staticClass: "cart icon"
    }), _vm._v(" " + _vm._s(_vm.howManyInCart(item)) + " gab.\n           ")]), _vm._v(" "), _c('div', {
      staticClass: "ui  button",
      on: {
        "click": function($event) {
          return _vm.addItemToCart(item)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    })])])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ui clearing segment"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('paginator', {
    attrs: {
      "paginator": _vm.paginator,
      "link-name": "goods-page"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59d5bf3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaitingForDeliveryAddGoodsPage.vue
// module id = 347
// module chunks = 1